import { MessageContentBlock } from "@hex/common";

import { AgentChatMessageFragment } from "../hex-project-shared/messages/AgentChatMessage.generated";

import { AgentChatMessage, AgentChatThread } from "./agentChatMessage.types";
import {
  AgentChatThreadFragment,
  AgentChatThreadListItemFragment,
} from "./sharedThreadManagementUtils.generated";

export const messageFragmentToAgentChatMessage = (
  m: AgentChatMessageFragment,
): AgentChatMessage => {
  return {
    id: m.id,
    role: m.role,
    staticId: m.staticId,
    revision: m.revision,
    content: m.content as MessageContentBlock[],
    createdDate: m.createdDate,
    initiatedDate: m.initiatedDate,
    agentChatThreadId: m.agentChatThreadId,
    user: m.user ?? null,
    runId: m.runId,
    debugInfo: m.debugInfo,
    subagentType: m.subagentType ?? null,
    feedback: m.feedback,
  };
};

export const threadFragmentToAgentChatThread = (
  t: AgentChatThreadFragment | AgentChatThreadListItemFragment,
): AgentChatThread => {
  return {
    id: t.id,
    hexId: t.hexId,
    hexVersionId: t.hexVersionId,
    title: t.title,
    createdDate: t.createdDate,
    status: t.status,
    type: t.type,
    autoSaveHexVersionId: t.autoSaveHexVersionId,
    agentMessages: [],
    editsToReview: [],
    userId: t.user?.id ?? null,
    userName: t.user?.name ?? null,
    canPrompt: t.canPrompt,
    lastUsedModel: "lastUsedModel" in t ? t.lastUsedModel : null,
    lastUsedEffortLevel:
      "lastUsedEffortLevel" in t ? t.lastUsedEffortLevel : null,
    lastUsedSpeed: "lastUsedSpeed" in t ? t.lastUsedSpeed : null,
    messageCount: "messageCount" in t ? t.messageCount : 0,
    sensitive: t.sensitive,
    // List-item fragments don't carry `agentMessages`; conservatively
    // assume no truncation until the full thread is loaded.
    hasEarlierMessages:
      "agentMessages" in t
        ? (t.agentMessages.pageInfo?.hasPreviousPage ?? false)
        : false,
    startCursor:
      "agentMessages" in t
        ? (t.agentMessages.pageInfo?.startCursor ?? null)
        : null,
  };
};
